import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
// import ArrayHelper from 'helpers/array-helper';
// import Const from 'constants';
// import {getSimplexUnitName} from 'helpers/simplex-helper';

export default class LpClassic extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
        dispatch(Action.do('createGroupsOfTeamStacks', preparedPlayers.groupedBy.property('team')));
    }

    // minTeams({incomingValues = {}}) {
    //     const {teams = {}} = incomingValues;
    //     const state = Action.getState();
    //     const {sportConfig} = state;
    //     let teamRows = {},
    //         couples = {},
    //         result = '',
    //         maxPlayersInTeam = sportConfig.getConfigProp('playersInTeam') - 1,
    //         minTeams = Number(sportConfig.getConfigProp('minTeams'));
    //
    //     Object.keys(teams).map((teamName) => {
    //         let players = teams[teamName],
    //             addedPlayers = [];
    //         teamRows[teamName] = '';
    //         players.map((player) => {
    //             if (!inArray(player.uniqueId, addedPlayers)) {
    //                 teamRows[teamName] += '+' + getSimplexUnitName(player.uniqueId);
    //                 addedPlayers.push(player.uniqueId);
    //             }
    //         });
    //     });
    //
    //     if (ArrayHelper.countItems(teams) > minTeams) {
    //         Object.keys(teamRows).map((tn1) => {
    //             Object.keys(teamRows).map((tn2) => {
    //                 if (tn1 !== tn2) {
    //                     let combi1 = tn1 + tn2,
    //                         combi2 = tn2 + tn1;
    //                     if (!couples.hasOwnProperty(combi1) && !couples.hasOwnProperty(combi2)) {
    //                         couples[combi1] = teamRows[tn1] + teamRows[tn2];
    //                     }
    //                 }
    //             });
    //         });
    //         Object.keys(couples).map((key) => {
    //             result += couples[key] + '<=' + maxPlayersInTeam + '\n';
    //         });
    //     } else {
    //         Object.keys(teamRows).map((key) => {
    //             result += teamRows[key] + '>=1\n';
    //         });
    //     }
    //
    //     return result;
    // }

    // prepareSectionByPositionWithSuperFlexMaxExposure({incomingValues = {}}) {
    //     const {
    //         sportConfig,
    //         playersData: {preparedPlayers},
    //     } = Action.getState();
    //     const players = preparedPlayers.groupedBy.allowedPositions();
    //     const forbiddenSuperFlexPositions = this.exec('getForbiddenSuperFlexMaxExposurePositions');
    //
    //     let flexPositions = sportConfig.getConfigProp('flexPlayerPosition');
    //     let positions = sportConfig.getConfigProp('positions');
    //     let superFlexPosition = positions[flexPositions[Const.POSITION_SUPERFLEX]];
    //
    //     let decrementFlex = false;
    //     let decrementSuperFlex = false;
    //
    //     let result = '';
    //     Object.keys(positions).map((pos) => {
    //         let playersOnPos = {};
    //         let addedPlayers = [];
    //         let posObj = positions[pos];
    //         let isPositionFlex = posObj.id === 'flex';
    //
    //         players.map((player) => {
    //             if (!inArray(player.position, posObj.allowedPositions) || inArray(player.uniqueId, addedPlayers)) {
    //                 return;
    //             }
    //
    //             if (!playersOnPos.hasOwnProperty(player.team)) {
    //                 playersOnPos[player.team] = '';
    //             }
    //
    //             playersOnPos[player.team] += '+' + getSimplexUnitName(player.uniqueId);
    //
    //             addedPlayers.push(player.uniqueId);
    //         });
    //
    //         if (isEmpty(playersOnPos)) {
    //             return;
    //         }
    //
    //         let str = '';
    //         Object.keys(playersOnPos).map((teamName) => {
    //             if (posObj.maxFromOneTeam) {
    //                 result += playersOnPos[teamName] + '<=' + posObj.maxFromOneTeam + '\n';
    //             } else {
    //                 str += playersOnPos[teamName];
    //             }
    //         });
    //
    //         if (str) {
    //             let forbiddenMaxPlayersQuantity = 0;
    //             let forbiddenMinPlayersQuantity = 0;
    //
    //             if (!isPositionFlex && !isEmpty(forbiddenSuperFlexPositions)) {
    //                 let countSuperFlex = ArrayHelper.countItems(forbiddenSuperFlexPositions);
    //                 if (inArray(posObj.shortName, Object.keys(forbiddenSuperFlexPositions))) {
    //                     forbiddenMaxPlayersQuantity += forbiddenSuperFlexPositions[posObj.shortName];
    //                     //case when all value are 0
    //                     if (superFlexPosition.allowedPositions.length === countSuperFlex) {
    //                         decrementSuperFlex = true;
    //                     }
    //                 } else if (
    //                     superFlexPosition.allowedPositions.length - 1 === countSuperFlex &&
    //                     arrayDuplicates(posObj.allowedPositions, superFlexPosition.allowedPositions).length > 0
    //                 ) {
    //                     forbiddenMinPlayersQuantity++;
    //                 }
    //             }
    //
    //             if (isPositionFlex && (decrementFlex || decrementSuperFlex)) {
    //                 forbiddenMaxPlayersQuantity++;
    //             }
    //
    //             if (false !== Boolean(posObj.minPlayers)) {
    //                 result += str + '=>' + (posObj.minPlayers + forbiddenMinPlayersQuantity) + '\n';
    //             }
    //             if (false !== Boolean(posObj.maxPlayers)) {
    //                 result += str + '<=' + (posObj.maxPlayers - forbiddenMaxPlayersQuantity) + '\n';
    //             }
    //         }
    //     });
    //
    //     return result;
    // }
    //
    // getForbiddenSuperFlexMaxExposurePositions({incomingValues = {}}) {
    //     const state = Action.getState();
    //     const {lineupsQuantity} = state;
    //     const {superFlexMaxExposurePositions} = state.playersData;
    //     const usedPlayers = this.store.get('usedPlayers', []);
    //     let result = {};
    //     if (!isEmpty(superFlexMaxExposurePositions)) {
    //         const flexPositionStats = this.store.get('flexPositionStats', {});
    //
    //         if (!isEmpty(usedPlayers)) {
    //             let lastLineup = usedPlayers[usedPlayers.length - 1];
    //             let flexPositions = this.exec('defineFlexPositionsInLineupByPositionsOrder', {
    //                 lineup: lastLineup,
    //             });
    //             flexPositions.map((flexPosition) => {
    //                 if (!flexPositionStats.hasOwnProperty(flexPosition)) {
    //                     flexPositionStats[flexPosition] = 0;
    //                 }
    //                 flexPositionStats[flexPosition]++;
    //             });
    //             this.store.set('flexPositionStats', flexPositionStats);
    //         }
    //
    //         Object.keys(superFlexMaxExposurePositions).map((posName) => {
    //             let usageQuantity = superFlexMaxExposurePositions[posName];
    //             if (Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE > usageQuantity) {
    //                 let usedInLineups = 0;
    //                 if (flexPositionStats.hasOwnProperty(posName)) {
    //                     usedInLineups = flexPositionStats[posName];
    //                 }
    //
    //                 let usedInLineupsPercentage = (1 / lineupsQuantity.getLineupsQuantity()) * 100;
    //                 if (usedInLineups > 0) {
    //                     usedInLineupsPercentage = (usedInLineups / lineupsQuantity.getLineupsQuantity()) * 100;
    //                 }
    //
    //                 if (usedInLineupsPercentage >= usageQuantity || usageQuantity === 0) {
    //                     result[posName] = 1;
    //                 }
    //             }
    //         });
    //     }
    //
    //     return {...result};
    // }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('player', {}, ''),
            salary: this.exec('salary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, ''),
            maxPlayersFromTeam: this.exec('maxPlayersFromTeam', {}, ''),
            minTeams: this.exec('minTeams', {}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {}, ''),
            teamNameStacking: this.exec('teamNameStacking', {}, ''),
            passReceiver: this.exec('passReceiver', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {}, ''),
            createdLineups: this.exec('createdLineups', {}, ''),
            exposureMax: this.exec('exposureMax', {}, ''),
            exposureMin: this.exec('exposureMin', {}, ''),
            flexExposureMax: this.exec('flexMaxExposure', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
